/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import JournalEventBasedComponent from "parog-web/components/forc/abstract/journal-event-based-component";
import JournalEventRetrievalStrategies from "parog-web/components/forc/utils/journal-event-retrieval-strategies";
import DigitalCareDeclaredJournalEvent from "parog-web/models/digital-care-declared-journal-event";

export default class DigitalCareFormComponent extends JournalEventBasedComponent {
  static forcDisplayName = "Prise en charge numérique";
  static fullComponentId = "digital-care/edition-form";

  static journalEventClass = DigitalCareDeclaredJournalEvent;
  journalEventProperties = [
    "occurredAt",
    "simpleDigitalCare",
    "happyNeuronDigitalCare",
    "happyNeuronBeginDate",
    "happyNeuronEndDate",
    "comments"
  ];
  retrieveJournalEvent =
    JournalEventRetrievalStrategies.sourceOrLastJournalEvent;

  computePayload() {
    const payload = super.computePayload();
    payload.occurredAt = new Date();
    return payload;
  }

  @action
  onBeginDateChanged(date) {
    this.changeset.set("happyNeuronBeginDate", date);
    const endDate = new Date(date);
    endDate.setMonth(date.getMonth() + 3);
    this.changeset.set("happyNeuronEndDate", endDate);
  }
}
